import { render, staticRenderFns } from "./AssessmentVideos.vue?vue&type=template&id=6d57f856&scoped=true&"
import script from "./AssessmentVideos.vue?vue&type=script&lang=js&"
export * from "./AssessmentVideos.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentVideos.vue?vue&type=style&index=0&id=6d57f856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d57f856",
  null
  
)

export default component.exports